import { t } from "i18next";
import { z } from "zod";

export const authorSchema = z.object({
  id: z.string().optional(),

  artistesAuteursDescriptionPrenom: z
    .string()
    .nonempty(t("form.error.emptyField")),
  artistesAuteursDescriptionNom: z
    .string()
    .nonempty(t("form.error.emptyField")),
});
